import { Injectable } from "@angular/core";
import { IGoogleAnalytics } from "../../viewer-components/interfaces/i-google-analytics";
import { GoogleAnalyticsCommunicatorService } from "../../viewer-components/services/communicators/google-analytics-communicator.service";

@Injectable({
  providedIn: "root",
})
export class GoogleAnalyticsService {
  constructor(protected googleAnalyticsCommunicatorService: GoogleAnalyticsCommunicatorService) {}

  setGoogleAnalyticsEvent(name: string, category: string, enabled: boolean, value?: string): void {
    const googleAnalyticsEvent: IGoogleAnalytics = {
      name,
      category,
      enabled,
      value,
    };
    this.onGoogleAnalyticsEvent(googleAnalyticsEvent);
  }

  /**
   * Throw event to save google analytics event
   *
   */
  onGoogleAnalyticsEvent(event: IGoogleAnalytics): void {
    this.googleAnalyticsCommunicatorService.addGoogleAnalyticEvent(event);
  }
}
